import {SHARED_DYN_WRAPPER_CONSTRAINTS_ANCESTORS} from '@packages/systems/core/constants/SharedConstraintRules';
import type {RelationshipConstraint} from '@packages/systems/constraints-types';
import type {UserComponentUsage} from './types';

const ancestorFlagNames: string[] =
  SHARED_DYN_WRAPPER_CONSTRAINTS_ANCESTORS.reduce<Array<any>>(function (
    elementTypes: string[],
    constraint: RelationshipConstraint
  ): string[] {
    if (Array.isArray(constraint.is)) {
      elementTypes.push(...constraint.is);
    } else if (typeof constraint.is === 'string') {
      elementTypes.push(constraint.is);
    }

    return elementTypes;
  }, []);

const ancestorFlagIndex: {
  [elementType: string]: string[];
} = ancestorFlagNames.reduce<Record<string, any>>((index, ancestorFlagName) => {
  index[ancestorFlagName] = ancestorFlagNames;
  return index;
}, {});

export function isAncestorToBeFlagged(elementType: string): boolean {
  return (
    ancestorFlagIndex.hasOwnProperty(elementType) || elementType === 'RichText'
  );
}

export function findConstrainingAncestorType(
  elementType: string,
  ancestorFlags: UserComponentUsage['ancestorFlags']
): string | null {
  const constrainingAncestorTypes = ancestorFlagIndex[elementType];

  if (!constrainingAncestorTypes) {
    return null;
  }

  for (const constrainingAncestorType of constrainingAncestorTypes) {
    if (ancestorFlags[constrainingAncestorType]) {
      return constrainingAncestorType;
    }
  }

  return null;
}

export function isConstrainedByUserComponentUsages(
  elementType: string,
  userComponentUsages: UserComponentUsage[]
): boolean {
  return userComponentUsages.some(({ancestorFlags}) => {
    return findConstrainingAncestorType(elementType, ancestorFlags);
  });
}

/**
 * Checks if the component is used inside a static Rich Text element.
 */
export function isInsideStaticRichText(
  userComponentUsages: UserComponentUsage[]
): boolean {
  return userComponentUsages.some(
    ({ancestorFlags}) => ancestorFlags['RichText'] === true
  );
}
